"use strict";

class WebinarsController {
  constructor() {
    this.params = new URL(window.location.href).searchParams;
    this.waMode = this.params.get('wa');
    this.default = this.params.get('default');
    this.course = this.params.get('course');
    this.pathname = window.location.pathname;
  }

  init() {
    if (!this.waMode && this.pathname.includes('/webinars')) {
      this.redirectToNewWebinars();
    }
  }

  redirectToNewWebinars() {
    let path = "";

    switch (this.default) {
      case "fourth":
        path = "/amazon-seller-training-courses";
        break;
      case "second":
        path = "/free-amazon-fba-masterclasses";
        break;
      case "third":
        path = "/university";
        break;
      default:
        path = "/amazon-private-label-course";
        break;
    }

    if (path === "/university" && this.course) {
      switch (this.course) {
        case "super-amazon-seller":
          path += "/amazon-course-superamazonseller";
          break;
        case "proven-amazon-course":
          path += "/proven-amazon-course";
          break;
        case "best-amazon-course":
          path += "/the-best-amazon-course";
          break;
        case "home-business-expert":
          path += "/amazon-dropshipping-course";
          break;
        case "amazon-fba-mastery":
          path += "/amazon-fba-mastery";
          break;
        case "amz-insiders-course":
          path += "/amz-insiders-course";
          break;
        case "amz-limitless-course":
          path += "/amazon-course-amz-limitless";
          break;
        default:
          break;
      }
    }

    if (path.length > 0) {
      window.location.replace(path);
    }
  }
}

module.exports = WebinarsController;
